/**
 * Size distribution of a purchase-order line (spec 0031 §4.5).
 * Subcollection: org/{orgId}/purchase-order/{purchaseOrderId}/item/{itemId}/breakdown
 *
 * Materialized only for products with a size grid; products without a grid do not
 * produce breakdown rows. Resolve the repository with context
 * `{ orgId, purchaseOrderId, itemId }`. Audit via {@link Auditable} / ChildCrudService.
 *
 * Mirror of {@link SalesOrderItemBreakdown} (0108 mold).
 */
export const PURCHASE_ORDER_ITEM_BREAKDOWN = 'PurchaseOrderItemBreakdown';
//# sourceMappingURL=purchase-order-item-breakdown.js.map